"use client";

import { cn } from "@/lib/utils";
import { useToast } from "@/hooks/useToast";

export function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col items-center gap-2 p-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            "pointer-events-auto w-full max-w-md rounded-2xl border px-4 py-3 shadow-lg backdrop-blur",
            toast.variant === "success" && "border-emerald-400/60 bg-emerald-500/10 text-emerald-50",
            toast.variant === "destructive" && "border-rose-400/60 bg-rose-500/10 text-rose-50",
            (!toast.variant || toast.variant === "info") && "border-slate-400/60 bg-slate-700/40 text-slate-100",
          )}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-sm font-semibold uppercase tracking-[0.3em]">{toast.title}</div>
              {toast.description && <p className="mt-1 text-xs text-slate-200">{toast.description}</p>}
            </div>
            <button
              type="button"
              onClick={() => toast.id && dismissToast(toast.id)}
              className="text-xs uppercase tracking-[0.3em] text-slate-200 hover:text-white"
            >
              Close
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
